import React from 'react';

const Testimonial = (props) => (
    <div className="Testimonial turnBlack" id="Testimonial">
        <div className="testimonial-wrapper bodyFont turnBlack">
            <p>{props.content}</p>
            <h3>{props.name}<br/>{props.title}</h3>
        </div>
    </div>
)

export default Testimonial;


// WEBPACK FOOTER //
// ./src/components/Testimonial.js